import { useEffect, useState } from 'react'

/** Animate a numeric value from 0 → target (same easing as Sensemaker dashboard tiles). */
export function useCountUp(target: number, durationMs = 700, decimals = 0): number {
  const [value, setValue] = useState(0)
  const factor = 10 ** decimals

  useEffect(() => {
    if (!Number.isFinite(target)) {
      setValue(0)
      return
    }
    const start = performance.now()
    let frame = 0
    const tick = (now: number) => {
      const progress = Math.min((now - start) / durationMs, 1)
      const raw = target * progress
      setValue(decimals === 0 ? Math.round(raw) : Math.round(raw * factor) / factor)
      if (progress < 1) {
        frame = requestAnimationFrame(tick)
      }
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [target, durationMs, decimals, factor])

  return value
}
